import script from "./Createpin.vue?vue&type=script&setup=true&lang=js"
export * from "./Createpin.vue?vue&type=script&setup=true&lang=js"

import "./Createpin.vue?vue&type=style&index=0&id=55921cf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55921cf8"]])

export default __exports__